export default {"src":"/_next/static/media/check-gray.c12a8f85.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};